import { IIdentity } from '.';

export interface TooltipContext<T extends IIdentity> {
  data: T;
  columnDef: string;
  allowDeleting?: boolean;
  allowDeletingRow?: boolean;
  allowEditing?: boolean;
}
